import { AppShell } from "@mantine/core";
import { Outlet } from "react-router-dom";
import { LandingHeader } from "./Header";
import { LandingFooter } from "./Footer";
import { NavMenu } from "./NavMenu";
import { useState } from "react";
import type { Metadata } from "./lib/Meta";
import styles from "./layout.module.css";

export const metadata: Metadata = {
  title: "Woolworths MarketPlus",
  description: "Landing page for Woolworths MarketPlus.",
};

export const LandingLayout = () => {
  const [opened, setOpened] = useState(false);

  const toggleOpen = () => {
    setOpened(!opened);
  };
  return (
    <html lang="en">
      <body className={styles.body}>
        <AppShell
          navbarOffsetBreakpoint="sm"
          padding="0"
          header={<LandingHeader toggleOpen={toggleOpen} opened={opened} />}
          navbar={<NavMenu opened={opened} />}
          footer={<LandingFooter />}
          styles={(theme) => ({
            main: {
              paddingTop: "100px",
              [theme.fn.smallerThan('sm')]: {
                paddingTop: "60px",
              },
              backgroundColor:
                theme.colorScheme === "dark"
                  ? theme.colors.dark[8]
                  : theme.colors.gray[0],
            },
          })}
        >
          <Outlet />
        </AppShell>
      </body>
    </html>
  );
};
